
/** DO NOT EDIT THIS FILE! */
import { Version } from '@angular/core';
import { Bundle } from './models';

export const VERSION = new Version('2.0.63');

export const BUNDLE: Bundle = {
  date: 1793848402915,
  commitSha: 'unknown',
  version: VERSION,
};
